import { CSSObject } from "@emotion/react";

export const filterContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
};
